import { AlertButtonToolbar } from "./ExplainabilityButton";
import '../webComponents/ExplainabilityButton';
import { updateXml } from "../../utlis/transitionUtils";

export class ChatFeedbackToolbar extends HTMLElement {
  private data: any;
  private audio: HTMLAudioElement | null = null;
  private isVoiceEnabled: boolean = false;

  private async speakWithAzure(text: string, isVoiceEnabled: boolean) {
    if (!isVoiceEnabled || !text) return;
  const utterance = new window.SpeechSynthesisUtterance(updateXml(text));
  utterance.lang = 'en-US';
  utterance.rate = 0.92;
  utterance.pitch = 1;
  const voices = window.speechSynthesis.getVoices();
  const auVoice = voices.find(v => v.lang === 'en-AU');
  if (auVoice) utterance.voice = auVoice;
  window.speechSynthesis.speak(utterance);
  }

  static get observedAttributes() {
    return ['datainput'];
  }

  constructor() {
    super();
    this.handleCopy = this.handleCopy.bind(this);
    this.handleLike = this.handleLike.bind(this);
    this.handleDislike = this.handleDislike.bind(this);
    this.handleComment = this.handleComment.bind(this);
    this.handleSendComment = this.handleSendComment.bind(this);
    this.handleVoiceToggle = this.handleVoiceToggle.bind(this);

    this.innerHTML = `
      <style>
        .icon {
          display: flex;
          align-items: end;
          width: 20px;
          height: 20px;
          margin: 5px;
          cursor: pointer;
          transition: fill 0.3s;
        }
        .like.active svg {
          fill: green;
        }
        .dislike.active svg {
          fill: red;
        }
        .comment-container {
          display: none;
          align-items: flex-end;
          margin-top: 10px;
          width: 100%;
          gap: 8px;
        }
        .comment-area {
          height: 40px;
          width: 100%;
          resize: vertical;
          font-size: 0.95em;
          padding: 4px 8px;
        }
        .send-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          margin-left: 4px;
          cursor: pointer;
          border: none;
          background: none;
          padding: 0;
          transition: background 0.2s;
          color: var(--send-icon-color, #1976d2); /* theme-aware color */
        }
        .send-icon svg {
          width: 20px;
          height: 20px;
          fill: currentColor;
          transition: fill 0.2s;
        }
        .send-icon:hover svg {
          fill: currentColor;
        }
        .comment-icon {
          height: 27px;
        }
           /* Optional: theme support with classes */
        :host(.dark-mode) .send-icon {
          color: #ffffff;
        }

        :host(.light-mode) .send-icon {
          color: #000000;
        }
      </style>
      <div style="display: flex; align-items: end; width: 100%">
        <div class="icon copy">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24" height="20px" width="20px" fill="currentColor">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14h2V5h14V3zm-2 4H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 14H9V9h8v12z"/>
          </svg>
        </div>
        <div class="icon like">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20px" width="20px" fill="currentColor">
            <path d="M1 21h4V9H1v12zM23 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 2 7.59 8.59C7.22 8.95 7 9.45 7 10v9c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1z"/>
          </svg>
        </div>
        <div class="icon dislike">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20px" width="20px" fill="currentColor">
            <path d="M15 3h-9c-.83 0-1.54.5-1.84 1.22L1.14 11.27c-.09.23-.14.47-.14.73v1c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 22l6.58-6.59c.37-.36.59-.86.59-1.41V3zM23 3h-4v12h4V3z"/>
          </svg>
        </div>
        <div class="icon comment comment-icon">
          <svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" viewBox="0 0 24 24" fill="currentColor">
            <path d="M4 4h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-4l-4 4-4-4H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          </svg>
        </div>
        <div class="icon voice">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
            <path d="M3 10v4h4l5 5V5l-5 5H3zm13.5 2a1.5 1.5 0 0 0 0-3v3zm0 0a1.5 1.5 0 0 0 0 3v-3z"/>
          </svg>
        </div>
        
      </div>
      <div class="comment-container">
        <textarea placeholder="Enter your comments here..." class="comment-area"></textarea>
        <button class="send-icon" title="Send" aria-label="Send">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
    `;
  }

  connectedCallback() {
    this.querySelector('.copy')?.addEventListener('click', this.handleCopy);
    this.querySelector('.like')?.addEventListener('click', this.handleLike);
    this.querySelector('.dislike')?.addEventListener('click', this.handleDislike);
    this.querySelector('.comment')?.addEventListener('click', this.handleComment);
    this.querySelector('.voice')?.addEventListener('click', this.handleVoiceToggle);
    this.querySelector('.send-icon')?.addEventListener('click', this.handleSendComment);
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'datainput') {
      try {
        this.data = JSON.parse(newValue);
        this.updateUI();
      } catch (error) {
        console.error('Invalid JSON input:', error);
      }
    }
  }

  private updateUI() {
    const likeIcon = this.querySelector('.like');
    const dislikeIcon = this.querySelector('.dislike');
    const commentArea = this.querySelector('.comment-area') as HTMLTextAreaElement;
    const commentContainer = this.querySelector('.comment-container') as HTMLDivElement;

    if (this.data.like) {
      likeIcon?.classList.add('active');
    } else {
      likeIcon?.classList.remove('active');
    }

    if (this.data.dislike) {
      dislikeIcon?.classList.add('active');
    } else {
      dislikeIcon?.classList.remove('active');
    }

    if (this.data.comment && commentArea) {
      commentArea.value = this.data.comment;
    }

    // Hide comment container on update
    if (commentContainer) commentContainer.style.display = 'none';
  }

  private handleCopy() {
    navigator.clipboard.writeText(this.data.response.response).then(() => {
      window.dispatchEvent(new CustomEvent('copySuccess', { detail: { message: 'Copied to clipboard!', chatId: this.data.cid, messageId: this.data.response.messageId } }));
    });
  }

  private handleLike() {
    const likeIcon = this.querySelector('.like');
    const dislikeIcon = this.querySelector('.dislike');

    const isLiked = !likeIcon?.classList.contains('active');
    likeIcon?.classList.toggle('active', isLiked);
    dislikeIcon?.classList.remove('active');

    window.dispatchEvent(new CustomEvent('likeClick', { detail: { liked: isLiked, disliked: false, chatId: this.data.cid, messageId: this.data.response.messageId, traceId: this.data.response.traceId } }));
  }

  private handleDislike() {
    const likeIcon = this.querySelector('.like');
    const dislikeIcon = this.querySelector('.dislike');

    const isDisliked = !dislikeIcon?.classList.contains('active');
    dislikeIcon?.classList.toggle('active', isDisliked);
    likeIcon?.classList.remove('active');
    window.dispatchEvent(new CustomEvent('dislikeClick', { detail: { liked: false, disliked: isDisliked, chatId: this.data.cid, messageId: this.data.response.messageId, traceId: this.data.response.traceId } }));
  }

  private handleComment() {
    const commentContainer = this.querySelector('.comment-container') as HTMLDivElement;
    if (commentContainer) {
      const isHidden = (commentContainer.style.display === 'none' || commentContainer.style.display === '');
      commentContainer.style.display = isHidden ? 'flex' : 'none';
    }
  }

  private handleSendComment() {
    const commentArea = this.querySelector('.comment-area') as HTMLTextAreaElement;
    const commentContainer = this.querySelector('.comment-container') as HTMLDivElement;
    if (commentArea && commentArea.value.trim() !== "") {
      window.dispatchEvent(new CustomEvent('commentSubmit', {
        detail: {
          comment: commentArea.value,
          chatId: this.data.cid,
          messageId: this.data.response.messageId,
          traceId: this.data.response.traceId
        }
      }));
      // Optionally hide after sending
      if (commentContainer) commentContainer.style.display = 'none';
    }
  }

  private handleVoiceToggle() {
    const voiceIcon: any = this.querySelector('.voice');
    this.isVoiceEnabled = !this.isVoiceEnabled;

    if (this.isVoiceEnabled) {
      voiceIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#1976d2" viewBox="0 0 20 20">
        <path d="M3 10v4h4l5 5V5l-5 5H3zm13.5 2a1.5 1.5 0 0 0 0-3v3zm0 0a1.5 1.5 0 0 0 0 3v-3z"/>
      </svg>
    `;
      voiceIcon.classList.remove('disabled');
      voiceIcon.classList.add('enabled');
    } else {
      voiceIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
        <path d="M3 10v4h4l5 5V5l-5 5H3zm13.5 2a1.5 1.5 0 0 0 0-3v3zm0 0a1.5 1.5 0 0 0 0 3v-3z"/>
      </svg>
    `;
      voiceIcon.classList.remove('enabled');
      voiceIcon.classList.add('disabled');
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }
    }
    if (this.isVoiceEnabled) {
      const textForSpeech = this.data.response.response;
      this.speakWithAzure(textForSpeech, this.isVoiceEnabled)
        .then(() => {
        })
        .catch((error) => {
          console.error('Error in speakWithAzure:', error);
        });
    } else {
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }
    }
  }
}
customElements.define('chat-feedback-toolbar', ChatFeedbackToolbar);